// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"57ea754c","206":"bf34b5ad","329":"1df2e8c2","498":"600962be"}[chunkId] + ".chunk.js";
};